import { Box } from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import { SavePlanForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';
import React from 'react';
import { useParams } from 'react-router-dom';



export type SavePlanVersionModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SavePlanVersionModalProps) => {
  const params = useParams();

  return (
    <BasicFormModalLayout.FC
      {...props}
      title='Save Plan Version'
      subTitle='Add new version of the plan'
      headerIcon={<CustomIcon.large.FC icon='CREATOR' />}
    >
      <Box
        height='inherit'
      >
        <SavePlanForm.FC
          id={props.id}
          versionOnly={true}
          installationId={params.installationId ?? ''}
          projectId={params.projectId ?? ''}
          handleClose={props.handleClose}
        />
      </Box>
    </BasicFormModalLayout.FC>
  );
};
